export default __webpack_public_path__ + "static/img16h-fb899e5c5a5d5c1ab80e1cba8905e17c.jpg";